import t from "./index953.js";
import o from "./index954.js";
import n from "./index955.js";
import c from "./index956.js";
import i from "./index957.js";
var s = "[object Boolean]", g = "[object Date]", u = "[object Map]", T = "[object Number]", b = "[object RegExp]", l = "[object Set]", m = "[object String]", y = "[object Symbol]", f = "[object ArrayBuffer]", p = "[object DataView]", j = "[object Float32Array]", A = "[object Float64Array]", w = "[object Int8Array]", d = "[object Int16Array]", B = "[object Int32Array]", x = "[object Uint8Array]", C = "[object Uint8ClampedArray]", D = "[object Uint16Array]", S = "[object Uint32Array]";
function R(a, r, U) {
  var e = a.constructor;
  switch (r) {
    case f:
      return t(a);
    case s:
    case g:
      return new e(+a);
    case p:
      return o(a);
    case j:
    case A:
    case w:
    case d:
    case B:
    case x:
    case C:
    case D:
    case S:
      return i(a);
    case u:
      return new e();
    case T:
    case m:
      return new e(a);
    case b:
      return n(a);
    case l:
      return new e();
    case y:
      return c(a);
  }
}
export {
  R as default
};
